import React, { Component } from 'react'
import intl from 'react-intl-universal'
import PropTypes from 'prop-types'
import EventItem from './CreateExperienceEventsItem'
import shortid from 'shortid'
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react'

@inject('create_experience')
@observer
class EventList extends Component {
  componentDidMount() {
    this.props.create_experience.clean()
  }
  handleEventAdd = async (event) => {
    event.preventDefault()
    this.props.create_experience.event__add()
  }
  render () {
    const {create_experience} = this.props
    const {events} = create_experience
    return (
      <div>
        {events.map((event, index) => {
          return <EventItem
            key={shortid.generate()}
            index={index}
          />
        })}

        <div className='b-form-row'>
          <div className='b-form-item b-form-item_x'>
            <button className='b-button b-button_primary b-button_x'
                    type='button'
                    onClick={this.handleEventAdd}
                    disabled={create_experience.duration < 0}
            >
              {intl.get('create_experience.add_event')}
            </button>
          </div>
        </div>
      </div>
    )
  }
}

EventList.propTypes = {
  onChangeEvents: PropTypes.func,
  create_experience: MobxPropTypes.observableObject
}

export default EventList



// WEBPACK FOOTER //
// ./src/components/CreateExperienceEvents.js